import React, { useEffect, useState } from "react"; // Import useEffect and useState
import { Box, Button, Typography } from "@mui/material"; // Import Button and Typography
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import axios from 'axios'; // Import Axios
import { Link, useNavigate } from 'react-router-dom'; // Import Link and useNavigate

const Products = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  // State to hold product data and pagination
  const [products, setProducts] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [totalCount, setTotalCount] = useState(0); // Total number of products
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Initialize navigate

  const fetchProducts = async (url) => {
    setLoading(true); // Set loading state
    try {
      const response = await axios.get(url || "https://cheebo-server.neuralbey.com/dashboard/store/productList/");
      console.log(response.data); 
      setProducts(response.data.results); // Set products from results
      setTotalCount(response.data.count); // Set total count of products
      setNextPage(response.data.next); // Set next page URL
      setPrevPage(response.data.previous); // Set previous page URL
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  useEffect(() => {
    fetchProducts(); // Fetch products on mount
  }, []); // Empty dependency array means this runs once on mount

  // Columns for DataGrid
  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    {
      field: "image", // New image field
      headerName: "Image",
      width: 100,
      renderCell: ({ row }) => (
        <img src={`https://cheebo-server.neuralbey.com${row.image}`} alt={row.title} style={{ width: '50px', height: '50px', borderRadius: '4px' }} />
      ),
    },
    {
      field: "title",
      headerName: "Title",
      flex: 2,
      renderCell: (params) => (
        <Link 
          to={`/store/productDetailsList/${params.row.id}`} // Adjusted route to include product_id in URL
          style={{ textDecoration: 'none', color: colors.greenAccent[300] }} // Style for link
        >
          {params.value}
        </Link>
      ),
    },    
    {
      field: "price",
      headerName: "Price",
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "seller",
      headerName: "Seller",
      flex: 1,
    },
    {
      field: "availability",
      headerName: "Availability",
      flex: 1,
      renderCell: (params) => (
        <span>{params.value ? 'In Stock' : 'Out of Stock'}</span>
      ),
    },
    // Add other fields as necessary based on your Product model
  ];

  return (
    <Box m="20px">
      <Header title="PRODUCTS" subtitle="Managing the Product List" />
      
      {/* Add Product Button */}
      <Box mb={2}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => navigate('/store/addProduct')} // Navigate to Add Product page
        >
          Add a Product
        </Button>
      </Box>

      {/* Display total and current count */}
      <Typography variant="h6">
        Total Products: {totalCount} | Currently Displayed: {products.length}
      </Typography>

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={products}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />
        
        {/* Pagination Controls */}
        <Box display="flex" justifyContent="space-between" mt={2}>
          <Button 
            variant="contained" 
            disabled={!prevPage} 
            onClick={() => fetchProducts(prevPage)} // Fetch previous page if available
          >
            Previous
          </Button>
          
          <Button 
            variant="contained" 
            disabled={!nextPage} 
            onClick={() => fetchProducts(nextPage)} // Fetch next page if available
          >
            Next
          </Button>
        </Box>
        
        {loading && <Typography>Loading...</Typography>} {/* Loading indicator */}
        
      </Box>
    </Box>
  );
};

export default Products;